
  import { Component, Vue } from 'vue-property-decorator'
  import { Tour, TourOptions } from '../'

@Component({
  components: {
    Tour,
  },
})
  export default class BasicTourExample extends Vue {
  // Opciones para el tour
  tourOptions: TourOptions = {
    showButtons: true,
    showProgress: true,
    showCloseButton: true,
    darkMode: false,
    backdropOpacity: 0.7,
  };

  // Configuración del tour de demostración
  demoTour = {
    id: 'demo-tour',
    name: 'Tour de Demostración',
    steps: [
      {
        target: '#tour-title',
        title: 'Bienvenido al Tour',
        content: 'Este es un sistema de tour personalizado sin dependencias externas.',
        placement: 'bottom',
      },
      {
        target: '#tour-description',
        title: 'Descripción',
        content: 'Aquí puedes ver una descripción detallada del sistema.',
        placement: 'bottom',
      },
      {
        target: '#tour-feature-1',
        title: 'Característica 1',
        content: 'Esta es la primera característica importante de nuestro sistema.',
        placement: 'right',
        highlightPadding: 8,
      },
      {
        target: '#tour-feature-2',
        title: 'Característica 2',
        content: 'Esta es la segunda característica importante de nuestro sistema.',
        placement: 'left',
        highlightPadding: 8,
      },
      {
        target: '#tour-button',
        title: 'Iniciar Tour',
        content: 'Puedes hacer clic aquí para reiniciar el tour en cualquier momento.',
        placement: 'top',
      },
    ],
    onComplete: () => {
      console.log('Tour completado')
      // Solo usar console.log para evitar problemas con 'this'
      console.info('¡Felicidades! Has completado el tour de demostración!')
    },
    onSkip: () => {
      console.log('Tour omitido')
    },
  };

  /**
   * Inicia el tour
   */
  startTour () {
    if (this.$refs.tour) {
      (this.$refs.tour as any).start()
    }
  }

  /**
   * Muestra un mensaje de finalización
   */
  showCompletionMessage () {
    // Usar nuestro sistema propio de notificaciones
    if (this.$tourNotifications) {
      // @ts-ignore - Ignoramos el error porque sabemos que existe
      this.$tourNotifications.success('¡Felicidades! Has completado el tour de demostración.')
    } else {
      // Fallback a console
      console.info('Tour completado: ¡Felicidades! Has completado el tour de demostración.')
    }
  }

  /**
   * Muestra una notificación en el sistema
   */
  showNotification (message: string) {
    // Usar nuestro sistema de notificaciones propio
    if (this.$tourNotifications) {
      // @ts-ignore - Ignoramos el error porque sabemos que existe
      this.$tourNotifications.success(message)
    } else {
      // Fallback a console
      console.info('Tour completado:', message)
    }
  }

  mounted () {
    // Preparar el tour
    this.prepareCompletionHandler()
  }

  /**
   * Prepara el manejador de eventos para cuando se completa el tour
   */
  prepareCompletionHandler () {
    // Salvamos referencia al componente para usarla en eventos
    const vm = this
    // Reemplazamos el método onComplete con uno que utilice la referencia correcta
    this.demoTour.onComplete = function () {
      console.log('Tour completado')
      vm.showCompletionMessage()
    }
  }
  }
